<template>
  <Datepicker
    :disabled="disabled"
    v-model="model"
    :auto-apply="!confirm"
    :min-date="minDate"
    :max-date="maxDate"
    :hide-input-icon="iconHide"
    locale="ru-RU"
    :enable-time-picker="enableTime"
    :format-locale="ru"
    format="dd.MM.uuuu"
    :range="range"
    :inline="inline"
    :ui="{ input: 'form-control' }"
    dark
  />
</template>
<script setup>
import Datepicker from '@vuepic/vue-datepicker'
import { ru } from 'date-fns/locale'

const model = defineModel()
defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  maxDate: {
    type: [String, Date],
    default: null,
  },
  minDate: {
    type: [String, Date],
    default: null,
  },
  iconHide: {
    type: Boolean,
  },
  enableTime: Boolean,
  range: Boolean,
  confirm: Boolean,
  inline: Boolean,
})
</script>
